var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocsOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 3.6 1.6 C 2.937 1.6 2.4 2.137 2.4 2.8 L 2.4 13.2 C 2.4 13.863 2.937 14.4 3.6 14.4 L 12.4 14.4 C 13.063 14.4 13.6 13.863 13.6 13.2 L 13.6 6.097 C 13.6 5.779 13.473 5.474 13.248 5.249 L 9.952 1.951 C 9.727 1.726 9.421 1.6 9.102 1.6 Z",
    fill: "#F66B31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.4 10.8 C 5.069 10.8 4.8 11.069 4.8 11.4 C 4.8 11.731 5.069 12 5.4 12 L 10.6 12 C 10.931 12 11.2 11.731 11.2 11.4 C 11.2 11.069 10.931 10.8 10.6 10.8 Z",
    fill: "#2e2f34"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 5.4 8.4 C 5.069 8.4 4.8 8.669 4.8 9 C 4.8 9.331 5.069 9.6 5.4 9.6 L 10.6 9.6 C 10.931 9.6 11.2 9.331 11.2 9 C 11.2 8.669 10.931 8.4 10.6 8.4 Z",
    fill: "#2e2f34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocsOrange);
export default __webpack_public_path__ + "static/media/docsOrange.612efb6e1d0a38c9fb79cf67f60a322f.svg";
export { ForwardRef as ReactComponent };